export const isDigits = (value) => /^\d{10}$/.test(value);
